<div class="side-panel-item" *ngIf="sidePanel.titleIsVisible()">
    <span style="float: left;">{{ sidePanel.title || 'Filter' }}</span>
    <span style="float: right;" *ngIf="sidePanel.onReload" (click)="sidePanel.onReload()"><a
            class="fa fa-fw fa-refresh"></a></span>
</div>
<ng-template [ngTemplateOutlet]="sidePanel.template"></ng-template>
